module.exports = __webpack_public_path__ + "static/media/27_VTA - Silicon Valley.8ccbfeb8.jpg";